// ABOUTME: platform3 translations for the slot picker's headings, controls and outcomes
// ABOUTME: The server writes the session title and invite text in the participant's language
import { SlotPickerText } from '@execonline-inc/slot-picker.private';
import { TranslationsState, t9n } from '../../Translations';

export const slotPickerText = (ts: TranslationsState): SlotPickerText => {
  const translate = t9n(ts);
  return {
    heading: translate('Schedule coaching sessions'),
    loading: translate('Loading available times...'),
    loadError: translate('We could not load available times.'),
    retry: translate('Try again'),
    previousWeek: translate('Previous week'),
    nextWeek: translate('Next week'),
    lengthLabel: translate('Session length'),
    minutes: (count) => translate('{{count}} min', { count }),
    timeZoneLabel: translate('Time zone'),
    emptyWeek: translate('No times are free this week. Try another week.'),
    selectedHeading: translate('Selected times'),
    noneSelected: translate('Pick one or more times from the calendar.'),
    remove: (time) => translate('Remove {{time}}', { time }),
    bookLabel: (count) => {
      switch (count) {
        case 0: {
          return translate('Book');
        }
        case 1: {
          return translate('Book 1 session');
        }
        default: {
          return translate('Book {{count}} sessions', { count });
        }
      }
    },
    limitNotice: (count) =>
      translate('You can book up to {{count}} sessions at a time.', { count }),
    booking: translate('Booking...'),
    bookingError: translate(
      'We could not confirm your booking. Check your upcoming sessions before trying again.',
    ),
    bookedHeading: (count) =>
      count === 1 ? translate('Your session is booked') : translate('Your sessions are booked'),
    inviteNotice: (email) =>
      translate('A calendar invitation is on its way to {{email}}.', { email }),
    unavailableHeading: translate('These times are no longer available'),
    failedHeading: translate('We could not book these times. Please try again in a few minutes.'),
    pickAnother: translate('Pick another time'),
    close: translate('Close'),
  };
};
